<template>
<div class="row">
<div class="col-md-12">

<div>
     <div class="p-1 d-flex justify-content-between"><p></p>
    <button type="button" class="cl-button-unstyled" v-on:click="close" title="close window">
                        <i class="far fa-window-close fa-2x"></i></button>   
    </div>
 <div class="cl-search" role="search">
      <div class="cl-search__input_box">
                <div class="cl-search_input">
                  
                     <input type="text" class="cl-search" v-model="searchTerm"
                        placeholder="Search CultureLabs" :name="name" v-on:keyup.enter="search">
                        <span id="searchclear" class="clearspan" >
                          <button type="button" class="cl-button-unstyled fas fa-times" v-on:click="clearSearchTerm" title="Clear text" ></button>
                          <button type="button" class="cl-button-unstyled fas fa-search" v-on:click="search" title="Search" ></button>
                        </span>
                        
                </div>
                       <div class="pull-right">
                         <button type="button" class=" cl-button-unstyled cl-search__input_box__clear" label="All tabs"  title="Show All tabs" v-on:click="resetSearch"><i class="fas fa-list"> </i>  Show All Tabs</button>
                         
                       
                        
                    </div>
                
                </div> 
            </div>   
 </div>
 
 </div>
 </div>
 
</template>

<script>
export default {
  props: {
    value: {
      default: ''
    },
    name: {
      default: ''
    }
  },
  data: function() {
    return { searchTerm: this.value ,
             btmessage: '<span> <i class="fa fa-search"></i></span><span class="label-icon"> Search</span>',
             loggeduser: true
    }
  },
   watch: {
    value: function(val) {
      this.searchTerm = val
    },
    searchTerm: function(val) {
      this.$emit('input', val)
    }
  },
  methods : {
    changeSearchSpace: function(event){
      
       this.btmessage=event.currentTarget.innerHTML
      
    },
    search: function(){
      this.$emit('searchWithTerm');
    },
    resetSearch: function(){
     // this.searchTerm = '';
      this.$emit('resetSearch',this.searchTerm);
     
    },
    clearSearchTerm: function(){
      if(this.searchTerm){
      this.searchTerm = '';
      this.$emit('clearSearchTerm','');}
     
      
    },
    close: function(){
      this.$emit('close','');
     
    }
  }
}
</script>
<style scoped>
 .dropdown-menu { min-width: 25px; }
 .dropdown-menu .label-icon { margin-left: 5px; }


 .cl-search {
    /*flex: none;*/
    display: flex;
    flex-direction: row;
    justify-content: stretch;
    width: 100%;
    border: 1px solid #fff;
    padding-right: 20px;
    font-size: 16px;
}


.cl-search__input_box {
    background-color: rgba(var(--sk_primary_background,255,255,255),1);
    height: 48px;
    flex-direction: row;
    display: flex;
    align-items: center;
    flex-grow: 1;
    min-width: 0;
    margin: 0;
    font-size: 14px;
}



.cl-search_input{
    flex-grow: 1;
    min-width: 0;
    background: transparent;
    border: none;
}



input.cl-search {
  background: transparent;
  border: 0px #fff;
  border-bottom: 1px solid #ccc;
  display: block;
  width: 80%;
  height: 34px;
  padding: 6px 12px;
}

input.cl-search:focus {
    border: none; 
    border-width: 0; 
    border-bottom: 1px solid #ccc;
    outline:none!important;
    box-shadow: none;
}


.cl-search__input_box__clear {
    border-right: 1px solid #ccc !important;
    border-left: 1px solid #ccc !important;
    font-size: 13px;
    padding: 0 16px;
}
.clearspan {
        color: rgba(var(--sk_foreground_max_solid,97,96,97),1); 
        float: right;
        width:20%;
        margin-right: 6px;
        margin-top: -20px;
        position: relative;
        z-index: 2;
        cursor: pointer;
    }


.cl-button-unstyled {
     color: rgba(var(--sk_foreground_max_solid,97,96,97),1);
       
    background: none;
    border: 0;
    margin: 0;
    cursor: pointer;
}



button.cl-button-unstyled:focus {outline:0;}

.cl-dropmenu {
    right: 3% !important;
}

</style>



// WEBPACK FOOTER //
// src/plugins/SearchPlugin/components/SearchBox.vue